import { useEffect, useState } from 'react';
import ValidatedInput, { ValidatedState } from '../../components/custom-input/ValidatedInput';
import { Validators } from '../../types/enums';
import { StorageCanister, StorageSite, StorageTank } from '../../types/interfaces';
import { updateStorageCanister } from '../../api/storageItemsApi';
import { showToast } from '../../services/toast.service';
import { toastMessages } from '../../constants/errorMessages';
import './locationManagement.scss';

type EditCanisterModalProps = {
  close: () => void;
  site: StorageSite;
  tank: StorageTank;
  canister: StorageCanister;
};

const EditCanisterModal = ({ close, site, tank, canister }: EditCanisterModalProps): JSX.Element => {
  const [nameInput, setNameInput] = useState<ValidatedState>({ valid: true, value: canister.name });
  const [activeInput, setActiveInput] = useState<boolean>(canister.active);
  const [validate, setValidate] = useState<boolean>(false);
  const [submit, setSubmit] = useState<boolean>(false);

  useEffect(() => {
    const action = async () => {
      try {
        await updateStorageCanister(canister.storageCanisterId, { name: nameInput.value, active: activeInput });
        showToast.success(toastMessages.CANISTER_UPDATE_SUCCESS);
      } catch (error) {
        showToast.success(toastMessages.CANISTER_UPDATE_FAIL);
      } finally {
        setSubmit(false);
        close();
      }
    };
    if (submit) {
      action();
    }
  }, [submit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setValidate(true);
    if (nameInput.valid) {
      setSubmit(true);
    }
  };

  return (
    <div className="management-columns-modal">
      <form onSubmit={handleSubmit}>
        <h2>Add Canister</h2>
        <p>Please complete the form to add a new canister.</p>
        <div className="form-row">
          <label>Site Name:</label>
          <div className="input-container">
            <label>{site.name}</label>
          </div>
        </div>
        <div className="form-row">
          <label>Tank Name:</label>
          <div className="input-container">
            <label>{tank.name}</label>
          </div>
        </div>
        <ValidatedInput
          useId="name-input-field"
          type="text"
          label={'Canister Name'}
          validate={validate}
          validatedStateForAutoFill={nameInput}
          setValidatedState={setNameInput}
          validators={[Validators.REQUIRED]}
        />
        <div className="form-row">
          <label htmlFor="active-checkbox">Active</label>
          <div className="input-container">
            <input
              id="active-checkbox"
              type="checkbox"
              defaultChecked={canister.active}
              onChange={e => setActiveInput(e.target.checked)}
            />
          </div>
        </div>
        <div className="flex-right submit-button">
          <button type="button" className="small green inverted button" onClick={close}>
            Cancel
          </button>
          &emsp;
          <button type="submit" className={nameInput.valid ? 'small green button' : 'small green button disabled'}>
            Update
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCanisterModal;
